<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <project-field-form-group :submissionId="submissionId" />
      <b-row>
        <b-col cols="2">
          <div class="display-3 font-3xl text-left">Samples</div>
        </b-col>
        <b-col>
          <b-form-group
            label="All Sample Types"
            :label-cols="2"
            :horizontal="true"
          >
            <b-form-input
              type="text"
              v-model="all_sample_types"
              placeholder="All Sample Types"
              :state="!$v.all_sample_types.$invalid"
              invalid-feedback="Required"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="currentSubmission && samples.length">
        <hr />
        <template v-for="(sample, index) in samples">
          <project-feed-mixer-sample
            :key="index"
            :submissionId="submissionId"
            :sampleId="sample.test_package_sample_id"
            @updateSampleList="updateSampleList"
          />
        </template>
      </div>
      <b-row align-h="end">
        <b-col cols="2">
          <b-button
            variant="success"
            block
            @click="updateSampleList({ action: 'add' })"
          >
            <i class="fa fa-plus" /> Add sample
          </b-button>
        </b-col>
      </b-row>
      <div v-if="serviceQuestions && serviceQuestions.length">
        <hr />
        <template v-for="(question, index) in serviceQuestions">
          <service-question :key="index" :serviceQuestion="question" />
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import ProjectFeedMixerSample from "./ProjectFeedMixerSample";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ProjectFeedMixerSubmissionForm",
  components: { ProjectFeedMixerSample, ProjectFieldFormGroup },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    serviceQuestions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    all_sample_types: {
      get() {
        return this.currentSubmission.submission_feed_mixer_efficiency
          .all_sample_types;
      },
      set(value) {
        this.UPDATE_SUBMISSION({
          id: this.submissionId,
          value: {
            ...this.currentSubmission,
            submission_feed_mixer_efficiency: {
              all_sample_types: value,
            },
            samples: this.currentSubmission.samples.map((sample) => ({
              ...sample,
              sample_feed_mixer_efficiency: {
                type: value,
              },
            })),
          },
        });
      },
    },
  },
  validations: {
    all_sample_types: { required },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    updateSampleList({ action, id }) {
      let listUpdate;
      switch (action) {
        case "add":
          this.samples.push({
            test_package_sample_id: this.$uuid.v4(),
            add_ons: [],
            identifier: `Sample ${this.samples.length + 1}`,
            sample_feed_mixer_efficiency: {
              type: this.all_sample_types,
            },
          });
          listUpdate = [...this.samples];
          break;
        case "remove":
          listUpdate = this.samples.filter(
            (sample) => sample.test_package_sample_id !== id
          );
          break;
        default:
      }
      this.handleSubmissionUpdate(
        listUpdate.map((sample, index) => {
          return {
            ...sample,
            identifier: `Sample ${index + 1}`,
          };
        }),
        "samples"
      );
    },
    handleSubmissionUpdate(value, field) {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value,
        name: field,
      });
    },
  },
};
</script>
